export const initPageJs = () => {
	if (document.querySelectorAll('.js-track-select-item').length) {
		window.track.trackViewItemList(document.querySelector('.js-track-view-item-list'));

		document.querySelectorAll('.js-track-select-item').forEach(el => {
	  		el.addEventListener('click', event => {
	  			event.preventDefault();
	  			window.track.trackSelectItem(event.currentTarget.dataset)
	  		})
		})
	}
}
